package io.jsonize.web.components

import androidx.compose.foundation.layout.*
import androidx.compose.material3.*
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import androidx.compose.ui.Alignment
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.Brightness4
import androidx.compose.material.icons.filled.History
import androidx.compose.material.icons.filled.BrightnessMedium
import androidx.compose.material.icons.filled.DarkMode
import androidx.compose.material.icons.filled.FormatSize
import androidx.compose.material.icons.filled.LightMode
import androidx.compose.material.icons.filled.Share
import androidx.compose.material.icons.filled.TextIncrease
import androidx.compose.ui.unit.sp
import io.jsonize.web.viewmodel.AppViewModel
import kotlinx.browser.window

@Composable
fun Toolbar(
//    onSizeIncrease: (() -> Unit)? = null,
//    onSizeDecrease: (() -> Unit)? = null,
    isDark: Boolean,
    onThemeToggle: () -> Unit ,
    onHistoryClick: () -> Unit
) {
    Surface(shadowElevation = 4.dp) {
        Row(
            modifier = Modifier
                .fillMaxWidth()
                .padding(horizontal = 12.dp, vertical = 6.dp),
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.SpaceBetween
        ) {

            Text(AppViewModel.SITE_NAME,
                fontSize = 18.sp,
                lineHeight = 18.sp,
                modifier = Modifier.padding(start = 10.dp))

            Row(verticalAlignment = Alignment.CenterVertically) {
                TooltipIconButton(
                    tooltip = "Toggle theme",
                    onClick = onThemeToggle
                ) {
                    Icon(
                        imageVector = if (isDark)
                            Icons.Default.LightMode else Icons.Default.DarkMode,
                        contentDescription = "Toggle Theme"
                    )
                }
                TooltipIconButton(
                    tooltip = "History",
                    onClick = onHistoryClick
                ) {
                    Icon(
                        imageVector = Icons.Default.History,
                        contentDescription = "History"
                    )
                }

                TooltipIconButton(
                    tooltip = "Share Jsonize",
                    onClick = { shareAppLink() }
                ) {
                    Icon(
                        imageVector = Icons.Default.Share,
                        contentDescription = "Share Jsonize"
                    )
                }

                /*IconButton(onClick = { onHistoryClick?.invoke() }) {
                    Icon(Icons.Default.History, contentDescription = "History")
                }*/
            }
        }
    }
}

private fun shareAppLink() {
    val url = window.location.href
    val navigator = window.navigator.asDynamic()
    val share = navigator.share
    if (share != null) {
        val data = js("({})")
        data.title = AppViewModel.SITE_NAME
        data.text = AppViewModel.SITE_DESCRIPTION
        data.url = url
        try {
            share.call(navigator, data)
            return
        } catch (_: dynamic) {
            // fall through to copy
        }
    }
    copyToClipboardFallback(url)
}

private fun copyToClipboardFallback(text: String) {
    val navigator = window.navigator.asDynamic()
    val clipboard = navigator.clipboard
    val writeText = clipboard?.writeText
    if (writeText != null) {
        writeText.call(clipboard, text)
    } else {
        window.prompt("Copy link", text)
    }
}

